import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import {
  ConfirmationNumberOutlined,
  ForumOutlined,
  MenuBookOutlined,
  PendingActionsOutlined,
  PersonAddAlt1Outlined,
  PostAddOutlined,
  SchoolOutlined,
  SettingsOutlined,
  StarHalfOutlined,
  ViewCarouselOutlined,
} from "@mui/icons-material";
import { Badge, Link } from "@mui/material";
import { useUserAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { usePendingListCount } from "../../context/PendingListContext";
import { useUserChats } from "../../context/ChatsContext";

const Sidebar = () => {
  const { logOut } = useUserAuth();
  const { countPendingList } = usePendingListCount();
  const { countChats } = useUserChats();
  const navigate = useNavigate();

  const handleClick = async () => {
    await logOut();
    navigate("/login");
  };

  return (
    <div className="sidebar">
      <div className="top">
<span className="logo">Admin Dashboard</span>
      </div>

      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link href="/" style={{ textDecoration: "none" }}>
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>

          <Link href="/users" style={{ textDecoration: "none" }}>
            <li>
              <PersonOutlineIcon className="icon" />
              <span>Users</span>
            </li>
          </Link>
          <Link href="/library" style={{ textDecoration: "none" }}>
            <li>
              <MenuBookOutlined className="icon" />
              <span>Ebooks</span>
            </li>
          </Link>
          <Link href="/orders" style={{ textDecoration: "none" }}>
            <li>
              <CreditCardIcon className="icon" />
              <span>Orders</span>
            </li>
          </Link>
          <Link href="/publishers" style={{ textDecoration: "none" }}>
            <li>
              <SchoolOutlined className="icon" />
              <span>Publishers</span>
            </li>
          </Link>
          <p className="title">SERVICES</p>
          <Link href="/add-book" style={{ textDecoration: "none" }}>
            <li>
              <PostAddOutlined className="icon" />
              <span>Add Ebook</span>
            </li>
          </Link>
          <Link href="/add-publisher" style={{ textDecoration: "none" }}>
            <li>
              <PersonAddAlt1Outlined className="icon" />
              <span>Add Publisher</span>
            </li>
          </Link>
          <Link href="/pending-books" style={{ textDecoration: "none" }}>
            <Badge color="error" badgeContent={countPendingList}>
              <li>
                <PendingActionsOutlined className="icon" />
                <span>Pending Ebooks</span>
              </li>
            </Badge>
          </Link>
          <Link href="/pending-reviews" style={{ textDecoration: "none" }}>
            <Badge color="error" badgeContent={0}>
              <li>
                <StarHalfOutlined className="icon" />
                <span>Pending Reviews</span>
              </li>
            </Badge>
          </Link>
          <Link href="/app-banners" style={{ textDecoration: "none" }}>
            <li>
              <ViewCarouselOutlined className="icon" />
              <span>Banners</span>
            </li>
          </Link>
          <Link href="/support" style={{ textDecoration: "none" }}>
            <Badge color="error" badgeContent={countChats}>
              <li>
                <ForumOutlined className="icon" />
                <span>Chat support</span>
              </li>
            </Badge>
          </Link>
          <Link href="/promocodes" style={{ textDecoration: "none" }}>
            <li>
              <ConfirmationNumberOutlined className="icon" />
              <span>Promo codes</span>
            </li>
          </Link>
          <Link href="/settings" style={{ textDecoration: "none" }}>
            <li>
              <SettingsOutlined className="icon" />
              <span>Settings</span>
            </li>
          </Link>
          <p className="title">USER</p>
          <li onClick={handleClick}>
            <ExitToAppIcon className="icon" />
            <span>Logout</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
